const info = [
  { key: 'Name', msg: '【基础信息】请输入真实姓名' },
  { key: 'Mobile', msg: '【基础信息】请输入手机号' },
  { key: 'Mobile',max:11, msg: '【基础信息】输入手机号不正确' },
  { key: 'Email', msg: '【基础信息】请输入邮箱' },
  { key: 'Email',regex:/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/, msg: '【基础信息】邮箱格式不正确' },
  { key: 'Sex', msg: '【基础信息】请选择性别' },
]

const infobyAll = [
  { key: 'Name', msg: '【基础信息】请输入真实姓名' },
  { key: 'Mobile', msg: '【基础信息】请输入手机号' },
  { key: 'Mobile',max:11, msg: '【基础信息】输入手机号不正确' },
  { key: 'Email', msg: '【基础信息】请输入邮箱' },
  { key: 'Email',regex:/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/, msg: '【基础信息】邮箱格式不正确' },
  { key: 'Sex', msg: '【基础信息】请选择性别' },
]

const job = [
  { key: 'Company', msg: '【实习/工作经历】请输入企业名称' },
  { key: 'Title', msg: '【实习/工作经历】请输入所任职位' },
  { key: 'StartDate', msg: '【实习/工作经历】请选择工作开始时间' },
  { key: 'EndDate', msg: '【实习/工作经历】请选择工作结束时间' },
  { key: 'Summary', msg: '【实习/工作经历】请输入工作描述' },
]

const jobbyAll = [
  { key: 'Company', msg: '【实习/工作经历】请输入企业名称' },
  { key: 'Title', msg: '【实习/工作经历】请输入所任职位' },
  { key: 'StartDate', msg: '【实习/工作经历】请选择工作开始时间' },
  { key: 'EndDate', msg: '【实习/工作经历】请选择工作结束时间' },
  { key: 'Summary', msg: '【实习/工作经历】请输入工作描述' },
]

const edu = [
  { key: 'School', msg: '【教育经历】请输入毕业院校' },
  { key: 'Speciality', msg: '【教育经历】请输入专业' },
  { key: 'StartDate', msg: '【教育经历】请选择教育开始时间' },
  { key: 'EndDate', msg: '【教育经历】请选择教育结束时间' },
  { key: 'Education', msg: '【教育经历】请选择学历' },
  { key: 'studyType', msg: '【教育经历】请选择是否统招' },
  { key: 'professionRanking', msg: '【教育经历】请选择专业排名' },
]

const edubyAll = [
  { key: 'School', msg: '【教育经历】请输入毕业院校' },
  { key: 'Speciality', msg: '【教育经历】请输入专业' },
  { key: 'StartDate', msg: '【教育经历】请选择教育开始时间' },
  { key: 'EndDate', msg: '【教育经历】请选择教育结束时间' },
  { key: 'Education', msg: '【教育经历】请选择学历' },
  { key: 'studyType', msg: '【教育经历】请选择是否统招' },
  { key: 'professionRanking', msg: '【教育经历】请选择专业排名' },
]


const pro = [
  { key: 'ProjectName', msg: '【项目经历】请输入项目名称' },
  { key: 'Title', msg: '【项目经历】请输入项目角色' },
  { key: 'StartDate', msg: '【项目经历】请选择项目开始时间' },
  { key: 'EndDate', msg: '【项目经历】请选择项目结束时间' },
  { key: 'ProjectDescription', msg: '【项目经历】请输入项目描述' },
  // { key: 'Responsibilities', msg: '【项目经历】请输入项目职责' },
]

const probyAll = [
  { key: 'ProjectName', msg: '【项目经历】请输入项目名称' },
  { key: 'Title', msg: '【项目经历】请输入项目角色' },
  { key: 'StartDate', msg: '【项目经历】请选择项目开始时间' },
  { key: 'EndDate', msg: '【项目经历】请选择项目结束时间' },
  { key: 'ProjectDescription', msg: '【项目经历】请输入项目描述' },
  // { key: 'Responsibilities', msg: '【项目经历】请输入项目职责' },
]

const work = [
  { key: 'url', msg: '【作品】请输入作品链接' },
  { key: 'url', regex:/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\\.-]+)+[\w\-\\._~:/?#[\]@!\\$&'\\*\\+,;=.]+$/,msg: '【作品】作品链接地址不正确' },
  // { key: 'description', msg: '请输入作品描述' },
]
const workbyAll = [
  { key: 'url', msg: '【作品】请输入作品链接' },
  { key: 'url', regex:/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\\.-]+)+[\w\-\\._~:/?#[\]@!\\$&'\\*\\+,;=.]+$/,msg: '【作品】作品链接地址不正确' },
  // { key: 'description', msg: '请输入作品描述' },
]

const inte = [
  { key: 'compayName', msg: '【实习经历】请输入企业名称' },
  { key: 'position', msg: '【实习经历】请输入所任职位' },
  { key: 'starttime', msg: '【实习经历】请选择工作开始时间' },
  { key: 'endtime', msg: '【实习经历】请选择工作结束时间' },
  { key: 'jobDetail', msg: '【实习经历】请输入工作描述' },
]

const intebyAll = [
  { key: 'compayName', msg: '【实习经历】请输入企业名称' },
  { key: 'position', msg: '【实习经历】请输入所任职位' },
  { key: 'starttime', msg: '【实习经历】请选择工作开始时间' },
  { key: 'endtime', msg: '【实习经历】请选择工作结束时间' },
  { key: 'jobDetail', msg: '【实习经历】请输入工作描述' },
]

const cont = [
  { key: 'name', msg: '【竞赛】请输入竞赛名称' },
  // { key: 'description', msg: '【实习经历】请输入竞赛描述' },
]
const contbyAll = [
  { key: 'name', msg: '【竞赛】请输入竞赛名称' },
  // { key: 'description', msg: '【实习经历】请输入竞赛描述' },
]

const cert = [
  { key: 'name', msg: '【证书】请输入证书名称' },
  // { key: 'description', msg: '【证书】请输入证书描述' },
]
const certbyAll = [
  { key: 'name', msg: '【证书】请输入证书名称' },
  // { key: 'description', msg: '【证书】请输入证书描述' },
]

const lang = [
  { condikey:'langtype',condivalue:'其他',key: 'Languages', msg: '【语言】请输入语言' },
  { condikey:'langtype',condivalue:'其他',key: 'Skills', msg: '【语言】请选择精通程度' },
  { condikey:'langtype',condivalue:'英语',key: 'grade', msg: '【语言】请选择等级' },
  { condikey:'langtype',condivalue:'英语',key: 'Score', msg: '【语言】请输入分数' },
  { condikey:'langtype',condivalue:'英语',key: 'Score', regex:/^\d+$/, msg: '【语言】输入分数格式不正确' },
]
const langbyAll = [
  { condikey:'langtype',condivalue:'其他',key: 'Languages', msg: '【语言】请输入语言' },
  { condikey:'langtype',condivalue:'其他',key: 'Skills', msg: '【语言】请选择精通程度' },
  { condikey:'langtype',condivalue:'英语',key: 'grade', msg: '【语言】请选择等级' },
  { condikey:'langtype',condivalue:'英语',key: 'Score', msg: '【语言】请输入分数' },
  { condikey:'langtype',condivalue:'英语',key: 'Score', regex:/^\d+$/, msg: '【语言】输入分数格式不正确' },
]

module.exports = {
  info: info,
  infobyAll: infobyAll,
  job: job,
  jobbyAll: jobbyAll,
  edu: edu,
  edubyAll: edubyAll,
  pro: pro,
  probyAll: probyAll,
  work:work,
  workbyAll:workbyAll,
  inte:inte,
  intebyAll:intebyAll,
  cont:cont,
  contbyAll:contbyAll,
  cert:cert,
  certbyAll:certbyAll,
  lang:lang,
  langbyAll:langbyAll,
}
